import React from 'react';
import { Flex, Box } from '@chakra-ui/react';

const Price = ({ value = `0.00`, currency = `£`, ...props }) => {
  return (
    <Flex flexDir="row" {...props}>
      <Box fontSize={{ base: `sm`, md: `md` }} color="gray.800">
        {currency}
      </Box>
      <Box as="span" fontSize={{ base: `sm`, md: `md` }} color="gray.800">
        {value}
      </Box>
      <Box
        ml=".2rem"
        mt=".1rem"
        fontSize={{ base: `xs`, md: `sm` }}
        color="gray.500">
        (RRP)
      </Box>
    </Flex>
  );
};

export default Price;
